export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "user_search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exam challenger search"])},
        "training_program": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("type")), " exams"])},
        "book_exam": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Book exam"])},
        "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
        "cancel_confirmation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to cancel?"])}
      },
      "fr": {
        "user_search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechercher candidat à l’examen"])},
        "training_program": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Examens de ", _interpolate(_named("type"))])},
        "book_exam": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Réserver l’examen"])},
        "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])},
        "cancel_confirmation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Êtes-vous sûr(e) de vouloir annuler cette réservation d’examen?"])}
      }
    }
  })
}